export default [
  {
    path: '/demo/old',
    name: 'demo-old',
    component: () => import('../views/Demo/Old')
  },
  {
    path: '/demo/md',
    name: 'demo-md',
    component: () => import('../views/Demo/Md')
  },
  {
    path: '/demo/form/new',
    name: 'demo-form-new',
    component: () => import('../views/Demo/Form')
  },
  {
    path: '/demo/form/re',
    name: 'demo-form-re',
    component: () => import('../views/Demo/FormRe')
  }
];
